// extracted by mini-css-extract-plugin
export default {"title":"NAyaw","text":"XRd6m"};